import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .closeRow {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    width: 100%;

    .closeIcon {
      color: ${({ theme }) => theme.button_high};
      font-size: 1.75rem;
    }
  }

  .iconRow {
    color: ${({ theme }) => theme.font_secondary};
    font-size: 2.75rem;
  }

  p {
    text-align: center;
    font-weight: 600;
    font-size: 1.125rem;
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
  span:last-child {
    margin-top: 1rem;
    width: 100%;
  }
`;
